import { useState } from "react";
import Form from "react-bootstrap/Form";

/**
 * Sepet satırına atanmış dinamik sipariş onay kutusu.
 *
 * Metin, ek açıklama ve sürüm backend'den (kategori / marka / ürün seviyesindeki
 * kuraldan) gelir; burada yalnızca çizilir. `consent` yoksa hiçbir şey render
 * edilmez — ürüne onay kutusu atanmamış demektir.
 *
 * Ek açıklama (`detailText`) opsiyoneldir: doluysa kutunun altında "Daha fazla
 * bilgi al" bağlantısı çıkar ve açılır panelde gösterilir; boşsa bağlantı hiç
 * çizilmez.
 *
 * @param {object}   consent    Sepet satırının consent alanı ({ ruleId, textVersion, text, detailText }).
 * @param {boolean}  checked    Kutunun işaretli olup olmadığı.
 * @param {function} onChange   (value: boolean) => void
 * @param {boolean}  showError  Kullanıcı onaylamadan devam etmeye çalıştıysa uyarıyı göster.
 * @param {string}   inputId    Aynı sayfada birden çok kutu olduğu için tekil id.
 */
const OrderConsentCheck = ({
  consent,
  checked,
  onChange,
  showError = false,
  inputId,
}) => {
  const [showDetail, setShowDetail] = useState(false);

  if (!consent?.ruleId) return null;

  const isInvalid = showError && !checked;
  const hasDetail = Boolean(consent.detailText && consent.detailText.trim());

  return (
    <div className="order-consent-check mt-2">
      <Form.Check
        type="checkbox"
        id={inputId}
        name={inputId}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        isInvalid={isInvalid}
        label={consent.text}
      />

      {hasDetail && (
        <div className="ms-4 mt-1">
          <a
            className="text-orange cursor-pointer text-decoration-underline small"
            onClick={(e) => {
              e.preventDefault();
              setShowDetail(!showDetail);
            }}
          >
            {showDetail ? "Daha az bilgi göster" : "Daha fazla bilgi al"}
          </a>

          {showDetail && (
            <div
              className="bg-gray-lightest rounded-3 p-3 mt-2 small fw-light"
              style={{ whiteSpace: "pre-line" }}
            >
              {consent.detailText}
            </div>
          )}
        </div>
      )}

      {isInvalid && (
        <div className="text-red small mt-1">
          Devam edebilmek için bu onayı vermeniz gerekmektedir.
        </div>
      )}
    </div>
  );
};

export default OrderConsentCheck;
